import React from 'react';
import Routing from './Routing/Routing';

const App = () => {
  return (
    <div>
      <Routing/>
    </div>
  );
}

export default App;
